import axios from "axios";
import { AuthHeader, url } from "../../utils/_exports";
const apiURL = "moc";

export const getMoCList = async (filter = {}, sort = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: { filter: JSON.stringify(filter), sort: JSON.stringify(sort) },
			...AuthHeader,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const addMoCItem = async (data: any, user: any, tenantKey: any) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	data.report_type = "moc";
	data.primary_author = user?.email?.toLowerCase();
	delete data.author;
	try {
		const response = await axios.post(
			`${url}/${apiURL}/add`,
			{ data, user: { email: user?.email, name: user?.name } },
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const updateMoC = async (id: string, data: any, options: any = {}) => {
	try {
		const response = await axios.put(
			`${url}/${apiURL}`,
			{
				filter: { _id: id },
				data: data,
				options: options,
			},
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateMoCItem = async (
	id: string,
	data: any,
	user: any,
	tenantKey: string,
	options: any = { upsert: true, new: true }
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.put(
			`${url}/${apiURL}/update`,
			{
				filter: { _id: id },
				data,
				user: { email: user?.email, name: user?.name },
				options,
			},
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const deleteMoCItem = async (id: string, tenantKey: any) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.post(
			`${url}/${apiURL}/delete`,
			{ filter: { _id: id } },
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};
